module.exports = __webpack_public_path__ + "static/fonts/OpenSansregular.5a798cda.ttf";